import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ClaimType, EmailAddress } from '@constants';
import { useBehaviorData } from '@hooks';
import { setDelayPackageId, clearSelectedDhgateItems } from '@store';

export const useChoose = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const setReportData = useBehaviorData();

  const {
    fulfilledItems,
    unFulfilledItems, orderName, delayPackageId, type,
  } = useSelector((state) => state.claim);
  const { platform, orderNumber, firstName } = useSelector((state) => state.policy);

  const onChange = (event) => {
    dispatch(setDelayPackageId(event?.target?.value));
  };

  const onClickTitle = (item) => {
    dispatch(setDelayPackageId(item.fulfilledId));
  };

  const onClickContinue = async () => {
    setReportData({ trackingTime: `${Date.now()}`, issueType: type });
    let path = '';
    if (type === ClaimType.Delay) {
      path = 'payment';
    } else {
      path = 'choose-items';
    }
    dispatch(clearSelectedDhgateItems());
    navigate(`../${path}`);
  };

  const onClickBack = () => {
    dispatch(setDelayPackageId(''));
  };

  const handleWrongMessageClick = (status, trackingNumber) => {
    const a = document.createElement('a');
    a.href = `mailto:${EmailAddress.Seel}?subject=Reporting Wrong Shipping Information for Order ${orderNumber} at DHgate&body=${encodeURIComponent(`Dear Seel team,\n\nI am unable to report my package ${type} due to inaccurate shipping information. Please help verify and update the latest shipping status of below package to facilitate the resolution process for my package issue.\nOrder Number: ${orderNumber}\nTracking Number: ${trackingNumber} \nCurrent Shipping Status: ${status}\n\nThanks,\n${firstName || ''}`)}`;
    a.innerHTML = EmailAddress.Seel;
    a.click();
  };

  return {
    fulfilledItems,
    unFulfilledItems,
    isBtnDisable: !delayPackageId,
    delayPackageId,
    orderName,
    handleWrongMessageClick,
    type,
    platform,
    onChange,
    onClickTitle,
    onClickContinue,
    onClickBack,
  };
};
